import {Component, OnInit, ViewChild} from '@angular/core';
import {fromEvent, Observable, Subscription} from 'rxjs';
import {AlertController, IonList} from '@ionic/angular';
import {APP_ROUTES, APP_STORAGE} from '../../../environments/environment';
import {ConfigurationObject, SettingsObj} from '../../interfaces/interfaces.regisafe';
import {SettingsService} from '../../provider/settings/settings.service';
import {StorageService} from '../../provider/storage/storage.service';
import {Capacitor} from '@capacitor/core';
import {AvailableResult, Credentials, NativeBiometric} from 'capacitor-native-biometric';
import {AppConfig} from '../../app.config';
import {ALERT_TXT} from '../../strings/language';
import {DateiSystemService} from '../../provider/datei-system/datei-system.service';
import {Router} from '@angular/router';
import {DeleteCredentialOptions} from 'capacitor-native-biometric/dist/esm/definitions';
import {App} from '@capacitor/app';

@Component({
	selector: 'app-einstellungen',
	templateUrl: './einstellungen.page.html',
	styleUrls: ['./einstellungen.page.scss'],
})
export class EinstellungenPage implements OnInit {

	// @ViewChild('slidingList') slidingList: IonList;
	//
	// resizeObservable$: Observable<Event>;
	// resizeSubscription$: Subscription;
	// showSlidingItems = false;
	public configuration: ConfigurationObject;
	settings: SettingsObj;
	biometric = false;
	biometricNotAvailable = true;
	offline = false;
	openInDefaulViewer = true;

	alert: HTMLIonAlertElement;

	constructor(private settingsService: SettingsService,
				private storageService: StorageService,
				private appConfig: AppConfig,
				private alertCtrl: AlertController,
				private dateiService: DateiSystemService,
				private router: Router) {
		this.configuration = this.appConfig.getConfig();
	}

	ngOnInit() {
		this.settings = this.settingsService.getUserSettings();
	}

	async ionViewDidEnter() {
		this.biometricAvailableCheck();
		this.offlineLoginCheck();
		this.defaultViewerCheck();
	}

	settingsChanged(event, key) {
		const value = event.detail.value;
		this.settingsService.setUserSettings(value, key);
	}

	/**
	 * biometricAvailableCheck()
	 *
	 * Prüfen ob Biometrischer Login aktiviert und Daten hinterlegt sind
	 */
	async biometricAvailableCheck() {
		if (Capacitor.getPlatform() !== 'web') {



			NativeBiometric.isAvailable()
				.then(async (result: AvailableResult) => {
					console.log('NativeBiometric.isAvailable: ', result);

					if (result.isAvailable) {
						this.biometricNotAvailable = false;
						this.biometric = false;
					}

					const biometriclogin = await this.storageService.getItem(APP_STORAGE.user.biometriclogin);
					if (biometriclogin === 2) {
						return false;
					}

					NativeBiometric.getCredentials({
						server: this.configuration.iqapiDomain
					})
						.then((credentials: Credentials) => {

							this.biometric = true;
						})
						.catch((error) => {
							this.biometric = false;
						});
				});
		} else {
			this.biometricNotAvailable = true;
			this.biometric = false;
		}
	}

	async toggleBiometricSetting(event) {
		console.log('toggleBiometricSetting: ', event);

		if (event.target.checked) {
			this.alert = await this.alertCtrl.create({
				header: ALERT_TXT.header.str00010,
				message: ALERT_TXT.message.str00060,
				buttons: [{
					text: ALERT_TXT.buttons.str00260,
					handler: () => {
						this.resetBiometricLogin();
					}
				}, {
					text: ALERT_TXT.buttons.str00240,
					handler: () => {
						this.deactivateBiometricLogin();
					}
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}]
			});

			await this.alert.present();
			await this.alert.onDidDismiss().then((data) => {
				if (data.role === 'backdrop' || data.role === 'cancel') {
					this.biometric = !this.biometric;
				}
			});
		} else {
			this.alert = await this.alertCtrl.create({
				header: ALERT_TXT.header.str00010,
				message: ALERT_TXT.message.str00070,
				buttons: [{
					text: ALERT_TXT.buttons.str00250,
					handler: () => {
						this.activateBiometricLogin();
					}
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}]
			});

			await this.alert.present();
			await this.alert.onDidDismiss().then((data) => {
				if (data.role === 'backdrop' || data.role === 'cancel') {
					this.biometric = !this.biometric;
				}
			});
		}
	}

	/**
	 * resetBiometricLogin()
	 *
	 * Biometrsichen Login zurücksetzen und Daten löschen
	 */
	async resetBiometricLogin() {
		console.log('resetBiometricLogin');
		NativeBiometric.deleteCredentials({
			server: this.configuration.iqapiDomain
		})
			.then((data) => {
				console.log('deleteCredentials: ', data);
				this.biometric = false;
				this.biometricNotAvailable = true;
				this.storageService.setItem(APP_STORAGE.user.biometriclogin, 0);
			})
			.catch((e) => {
				console.log('deleteCredentials error: ', e);
			});
	}

	/**
	 * deactivateBiometricLogin()
	 *
	 * Biometrischen Login 'nur' deaktivieren
	 */
	async deactivateBiometricLogin() {
		this.biometric = false;
		this.biometricNotAvailable = false;
		this.storageService.setItem(APP_STORAGE.user.biometriclogin, 2);
	}

	/**
	 * activateBiometricLogin()
	 *
	 * Biometric login auf '0' (default) setzen um zu Login navigieren
	 * oder falls 'nur' deaktiviert Wert auf 1 setzen
	 */
	async activateBiometricLogin() {
		const removeToken = await this.storageService.removeToken();
		this.router.navigate([APP_ROUTES.anmeldung]).then((data) => {
			setTimeout(async () => {
				const setItem = await this.storageService.setItem(APP_STORAGE.user.biometriclogin, 0);
			}, 500);
		});
	}

	/**
	 * offlineLoginCheck()
	 *
	 * prüfen ob Offline Login bereits durch Benutzer gesetzt ist.
	 * Die zugeörige Checkbox wird entsprechned gesetzt.
	 */
	async offlineLoginCheck() {
		const offlinelogin = await this.storageService.getItem(APP_STORAGE.user.offlinelogin);
		this.offline = offlinelogin === 1;
	}

	/**
	 * defaultViewerCheck()
	 *
	 * prüfen of Standard-Viewer für das Öffnen von Dokumenten gesetzt ist,
	 * Die zugeörige Checkbox wird entsprechned gesetzt.
	 */
	async defaultViewerCheck() {
		const defaultViewer = await this.storageService.getItem(APP_STORAGE.user.opendocsindefaultviewer);
		this.openInDefaulViewer = defaultViewer === 1;
	}

	/**
	 * toggleOfflineSetting()
	 *
	 * Benutzer setzt den Offline Login auf 'on' bzw. 'off'.
	 * je nach Status der Chekcbox aus 'toggleOfflineSetting()' wird der
	 * Offline Login entweder zurückgesetzt oder zum Login weitergeleitet
	 * damit der Benutzer nach erneutem Login den Offlinie Login wieder aktivieren kann
	 *
	 * @param event
	 */
	async toggleOfflineSetting(event) {

		if (event.target.checked) {
			this.alert = await this.alertCtrl.create({
				header: ALERT_TXT.header.str00010,
				message: ALERT_TXT.message.str00040,
				buttons: [{
					text: ALERT_TXT.buttons.str00260,
					handler: () => {
						this.resetOfflineLogin();
					}
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}]
			});

			await this.alert.present();
			await this.alert.onDidDismiss().then((data) => {
				if (data.role === 'backdrop' || data.role === 'cancel') {
					this.offline = !this.offline;
				}
			});
		} else {
			this.alert = await this.alertCtrl.create({
				header: ALERT_TXT.header.str00020,
				message: ALERT_TXT.message.str00050,
				buttons: [{
					text: ALERT_TXT.buttons.str00250,
					handler: () => {
						this.activateOfflineLogin();
					}
				}, {
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}]
			});

			await this.alert.present();
			await this.alert.onDidDismiss().then((data) => {
				if (data.role === 'backdrop' || data.role === 'cancel') {
					this.offline = !this.offline;
				}
			});
		}
	}

	/**
	 * resetOfflineLogin()
	 *
	 * Offline login zurücksetzen. Alle Daten aus der Datenbank und der
	 * Hash-Datei werden zurückgesetzt/gelöscht
	 */
	async resetOfflineLogin() {
		const setItem = await this.storageService.setItem(APP_STORAGE.user.offlinelogin, 2);
		const remove = await this.dateiService.schreibeDateiHash('--- // EMPTY // ---');
		console.log('resetOfflineLogin remove: ', remove);
	}

	/**
	 * activateOfflineLogin()
	 *
	 * Offline login auf '0' (default) setzen um zu Login navigieren
	 */
	async activateOfflineLogin() {
		const setItem = await this.storageService.setItem(APP_STORAGE.user.offlinelogin, 0);
		const removeToken = await this.storageService.removeToken();
		this.router.navigate([APP_ROUTES.anmeldung]);
	}
	
	async toggleDefaulViewerSetting(event) {
		if (event.detail.checked) {
			await this.storageService.setItem(APP_STORAGE.user.opendocsindefaultviewer, 1);
		} else {
			await this.storageService.setItem(APP_STORAGE.user.opendocsindefaultviewer, 0);
		}
	}


	// ngOnInit() {
	// 	this.handleSlidingItems();
	// 	this.resizeObservable$ = fromEvent(window, 'resize');
	// 	this.resizeSubscription$ = this.resizeObservable$.subscribe(evt => {
	// 		this.handleSlidingItems();
	// 	});
	// }

	// handleSlidingItems() {
	// 	const innerW = window.innerWidth;
	// 	this.showSlidingItems = innerW < 768;
	// 	if (typeof this.slidingList !== 'undefined') {
	// 		this.slidingList.closeSlidingItems();
	// 	}
	//
	// }

}
